export enum ReportGroupers{
  ACTIONS = "Ações",
  AUDITS = "Auditorias",
  INDICATORS = "Indicadores",
  STRATEGIC_MAPS = "Mapas Estratégicos",
  OCCURRENCES = "Ocorrências",
  PROJECTS = "Projetos",
  MEETINGS = "Reuniões",
  RISKS = "Riscos",
}

export default ReportGroupers;
